// Реквизиты оператора площадки — одно место для витрины (подвал, «Контакты»,
// «Оплата», «Возврат») и шлюза (HTML страниц без JavaScript). Банк-эквайер
// (Точка) при подключении интернет-эквайринга сверяет на сайте: наименование,
// ИНН, ОГРНИП, адрес, связь, оферту, способы оплаты, доставку, возврат и
// политики ПДн. Значения — из оферты OSMIX и карточки ИП; адрес и телефон
// выводятся, только когда заполнены, — пустых полей и заглушек на сайте быть не должно.
export const OPERATOR: {
	readonly entity: string;
	readonly inn: string;
	readonly ogrnip: string;
	readonly brand: string;
	readonly site: string;
	readonly supportEmail: string;
	readonly privacyEmail: string;
	readonly address: string;
	readonly phone: string;
} = {
	entity: "ИП Алавердян Михаил Аркадьевич",
	inn: "263099287687",
	ogrnip: "324080000017272",
	brand: "OSMIX",
	site: "osmix.ru",
	supportEmail: "osmix@osmix.ru",
	privacyEmail: "osmix@osmix.ru",
	address: "Респ. Калмыкия, Кетченеровский р-н, п. Кетченеры, пер. Школьный, д. 4, кв. 11",
	phone: "+7 925 565-65-65",
};

/** Реквизиты одной строкой: «ИП …, ИНН …, ОГРНИП …[, адрес]». */
export const operatorLine = (): string =>
	[OPERATOR.entity, `ИНН ${OPERATOR.inn}`, `ОГРНИП ${OPERATOR.ogrnip}`, OPERATOR.address].filter(Boolean).join(", ");
